module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"charactersLimit":"The maximum number of characters is","enterTheCorrectAnswer":"Enter the correct answer*","requiredField":"This field is required","enterANumValue":"Enter a numeric value"}}')
  delete Component.options._Ctor
}
